/**
 * @generated SignedSource<<e5be71a0cf025a58a984ab47a89032d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type JwtDeviceKindKind = "Admin" | "App" | "WebApp";
export type GenerateJWTForUserInput = {
  accountId: string;
  clientMutationId?: string | null;
  deviceKind: JwtDeviceKindKind;
  userId: string;
};
export type useAuthContext_GenerateJWTForUserMutation$variables = {
  input: GenerateJWTForUserInput;
};
export type useAuthContext_GenerateJWTForUserMutation$data = {
  readonly Auth: {
    readonly generateJWTForUser: {
      readonly jwtTokens: {
        readonly accessToken: string;
        readonly refreshToken: string;
      };
    } | null;
  };
};
export type useAuthContext_GenerateJWTForUserMutation = {
  response: useAuthContext_GenerateJWTForUserMutation$data;
  variables: useAuthContext_GenerateJWTForUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "GenerateJWTForUserPayload",
        "kind": "LinkedField",
        "name": "generateJWTForUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JwtLoginInformation",
            "kind": "LinkedField",
            "name": "jwtTokens",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refreshToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_GenerateJWTForUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_GenerateJWTForUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a97abaabd7dad47d0fc6c3f4c06face6",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_GenerateJWTForUserMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_GenerateJWTForUserMutation(\n  $input: GenerateJWTForUserInput!\n) {\n  Auth {\n    generateJWTForUser(input: $input) {\n      jwtTokens {\n        accessToken\n        refreshToken\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3efc94d2ec382db5032ab2d7bd8a609d";

export default node;
